module.exports = __webpack_public_path__ + "gfx/logo_safecall_go_login.png";